module.exports = __webpack_public_path__ + "static/media/available_rules.9125f395.svg";